import React from "react";
import { Container, Grid } from "@material-ui/core";
import CardExpenses from "./CardExpenses";
import NewExpense from "./NewExpense"
import { useRole } from "../../hooks/useRole";

export default function Expenses() {
  const { isAdmin } = useRole();

  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardExpenses />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewExpense />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
